import { StyleSheet, Dimensions } from 'react-native'
import { TabsModel } from './LinealTabs'
import theme from '../../../theme'
import { RoundedTabsTheme } from '../../../themeConstants'

const { width } = Dimensions.get('window')
const { height } = Dimensions.get('screen')

const styles = ({
    length = 1,
    gradient = false,
}: {
    length: number
    gradient?: boolean
}) => {
    const tabWidth = ((100 / length).toFixed(0) + '%') as `${number}%` // ancho dinamico de cada tab
    // console.log('TAB WIDTH:', tabWidth, 'LENGTH:', length)
    return StyleSheet.create({
        container: {
            flexDirection: 'row',
            paddingTop: 15,
            paddingBottom: 0,
            backgroundColor: 'white',
        },
        containerLinearGradient: {
            flexDirection: 'row',
            paddingVertical: 15,
            marginHorizontal: 12,
        },
        tab: {
            alignItems: 'center',
            width: tabWidth,
        },
        containerTabRounded: {
            flexDirection: 'row',
            borderRadius: 15,
            borderWidth: 1,
            borderColor: theme.colors.colorPrimary,
            height: 'auto',
            width: '100%',
        },
        tabRounded: {
            alignItems: 'center',
        },
        text: {
            fontSize: 15,
            fontWeight: 'bold',
        },
        textRoundedTabSelected: {
            fontSize: 15,
            color: RoundedTabsTheme.selectedTextColor,
            marginVertical: 5,
            fontWeight: 'bold',
        },
        textRoundedTabUnselected: {
            fontSize: 15,
            color: RoundedTabsTheme.unselectedTextColor,
            marginVertical: 5,
            fontWeight: 'normal',
        },
        divider: {
            height: 2,
            marginTop: 5,
            width: '100%',
        },
        marginRight: {
            marginRight: 4,
        },
        containerSections: {
            flex: 1.5,
            flexDirection: 'row',
            justifyContent: 'space-evenly',
            backgroundColor: theme.colors.formsBackground,
        },
        section: {
            flex: 1,
            alignItems: 'center',
            justifyContent: 'center',
        },
        sectionIcon: {
            width: 36,
            height: 36,
            borderRadius: 18,
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: 'white',
        },
        sectionTitle: {
            fontSize: 15,
            fontWeight: 'normal',
        },
        spacer: {
            height: 4,
        },
        containerNoMargin: {
            flexDirection: 'row',
            justifyContent: 'space-between',
            paddingVertical: 0,
            marginHorizontal: 12,
        },
    })
}
export default styles
